
import { Link } from "react-router-dom";
import { UserCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const ApproachesHeader = () => {
  const { t } = useTranslation('training');
  
  return (
    <div className="flex justify-between mb-4">
      <div className="text-golf-600">
        <Link to="/" className="text-green-600 hover:text-green-700 flex items-center gap-2">
          <UserCircle className="h-6 w-6" />
          <span>{t('approaches.backToDashboard')}</span>
        </Link>
      </div>
    </div>
  );
};

export default ApproachesHeader;
